import { render } from "./TermsOfUse.vue?vue&type=template&id=60e64562"
import script from "./TermsOfUse.vue?vue&type=script&lang=js"
export * from "./TermsOfUse.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jirizavadil/dev/tumorshot-web/app/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])